import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CollectionPage from './pages/CollectionPage';
import CartPage from './pages/CartPage';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/my-collection" element={<CollectionPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/my-collection/cart" element={<CartPage />} />
            <Route path="/navratri-collection" element={<Navigate to="/my-collection" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </CartProvider>
    </div>
  );
}

export default App;